(function ($) {
    'use strict';

    $.fn.collapsibleText = function () {
        var $self = $(this);
        var maxLines = $self.data('maxLines') || 0;
        var lineHeight = parseFloat($self.css('lineHeight'));
        var collapseText = $self.data('textCollapse') || 'Свернуть';
        var expandText = $self.data('textExpand') || 'Развернуть';
        var originalText = $self.text();

        var expand = function () {};
        var collapse = function () {};
        var init = function () {};

        init();

        return this;
    };
})(jQuery);
